export const padTypeCode = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.slice(0, 3).padStart(3, '0');
};

export const fitting = (position, name, itemNo, torqueKey, details = '') => ({
  position,
  name,
  itemNo: itemNo ? String(itemNo) : '',
  torqueKey,
  details,
});
